import { render, staticRenderFns } from "./representacao.vue?vue&type=template&id=844b21a8&"
import script from "./representacao.vue?vue&type=script&lang=js&"
export * from "./representacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports